// cSpell: words mapboxgl saleticket mapbox gmap
import { SaleTicket, Image, Ticket } from "../global-commons/type";
import { getTicket, listAllSaleTickets } from "../global-commons/apiUtil";
import { DATA_BLOCK } from "./dataBlockUtil";
import { Languages } from "../global-commons/i18n/base";
import {
  MOBILE_WIDTH,
  getMobileDrawerInitialTop,
  UPPER_NAVBAR_HEIGHT,
  MIDDLE_NAVBAR_HEIGHT,
  createTicketCard,
} from "./gmapCommon";

/** 販売チケット詳細ドロワーを開く */
export async function openSaleTicketDetailDrawer(saleTicket: SaleTicket) {
  const detailDrawer = document.getElementById("sale-ticket-detail-drawer");
  if (!detailDrawer) {
    throw new Error("sale-ticket-detail-drawer not found");
  }

  // ドロワーが開いている状態であることを示すために
  // インラインスタイルにtop: 0px;をセットする
  detailDrawer.style.top = "0px";

  // スクロール可能なコンテンツのスクロール位置を初期化する
  const saleTicketDetailDrawerContent = document.getElementById(
    "sale-ticket-detail-drawer-content",
  );
  if (!saleTicketDetailDrawerContent) {
    throw new Error("sale-ticket-detail-drawer-content not found");
  }
  saleTicketDetailDrawerContent.scrollTop = 0;

  document.getElementById("sale-ticket-detail-drawer-title")!.textContent =
    saleTicket.subject;
  document.getElementById("sale-ticket-detail-drawer-description")!.innerText =
    saleTicket.description;
  const saleTicketDetailDrawerPrice = document.getElementById(
    "sale-ticket-detail-drawer-price",
  );
  if (!saleTicketDetailDrawerPrice) {
    throw new Error("sale-ticket-detail-drawer-price not found");
  }
  saleTicketDetailDrawerPrice.innerHTML = "";
  for (let i = 0; i < saleTicket.price.length; i++) {
    const priceElement = document.createElement("p");
    priceElement.innerText =
      saleTicket.minimumPrice[i] === null
        ? saleTicket.priceClass[i] +
          ": " +
          saleTicket.price[i].toLocaleString() +
          DATA_BLOCK.getI18n()["map.yen"]
        : saleTicket.priceClass[i] +
          ": " +
          saleTicket.minimumPrice[i]!.toLocaleString() +
          " ~ " +
          saleTicket.price[i].toLocaleString() +
          DATA_BLOCK.getI18n()["map.yen"];
    saleTicketDetailDrawerPrice.appendChild(priceElement);
  }
  const imageContainer = document.getElementById(
    "sale-ticket-detail-drawer-image-container",
  );
  if (!imageContainer) {
    throw new Error("image container not found");
  }
  const saleTicketDetailDrawerIndicators = document.getElementById(
    "sale-ticket-detail-drawer-indicators",
  );
  if (!saleTicketDetailDrawerIndicators) {
    throw new Error("sale-ticket-detail-drawer-indicators not found");
  }

  imageContainer.innerHTML = "";
  saleTicketDetailDrawerIndicators.innerHTML = "";

  /** 販売チケットと関係する販売チケットの画像をすべてまとめる。 */

  const ticketModuleIds = saleTicket.tickets.map((ticket) => ticket.module_id);
  let images: Image[][] = [];
  const lang = location.pathname.split("/")[1];

  const tickets: Ticket[] = [];
  for (const ticketModuleId of ticketModuleIds) {
    const ticket = await getTicket(
      ticketModuleId.toString(),
      DATA_BLOCK.getEnv().API_URL,
      lang as Languages,
    );
    if (!ticket) {
      continue; // チケットが見つからない場合はスキップ
    }
    images.push(ticket.images);
    tickets.push(ticket);
  }

  images = images.concat([saleTicket.images]);

  const flattedImages = images
    .flat()
    .filter((image) => image.url !== "" && image.url != null);

  // カルーセル要素を取得し、画像が無い場合は非表示にする
  const saleTicketDetailCarousel = document.getElementById(
    "saleTicketDetailCarousel",
  );
  if (!saleTicketDetailCarousel) {
    throw new Error("saleTicketDetailCarousel not found");
  }

  if (flattedImages.length === 0) {
    saleTicketDetailCarousel.style.display = "none";
  } else {
    saleTicketDetailCarousel.style.display = "";

    for (const i in flattedImages) {
      const div = document.createElement("div");
      div.classList.add("carousel-item");
      if (i === "0") {
        div.classList.add("active");
      }

      const img = document.createElement("img");
      img.src = flattedImages[i].url;
      img.alt = flattedImages[i].desc ?? "";
      img.classList.add("d-block", "w-100", "drawer-image");

      div.appendChild(img);
      imageContainer.appendChild(div);

      // カルーセルのインジケータを追加する
      const indicator = document.createElement("button");
      indicator.type = "button";
      indicator.setAttribute("data-bs-target", "#saleTicketDetailCarousel");
      indicator.setAttribute("data-bs-slide-to", i);
      indicator.setAttribute("aria-label", `Slide ${parseInt(i) + 1}`);
      indicator.classList.add("override-background-color");
      if (i === "0") {
        indicator.classList.add("active");
        indicator.setAttribute("aria-current", "true");
      }
      saleTicketDetailDrawerIndicators.appendChild(indicator);
    }
  }

  // セット内容
  const saleTicketDetailDrawerSetList = document.getElementById(
    "sale-ticket-detail-drawer-set-list",
  );

  if (!saleTicketDetailDrawerSetList) {
    throw new Error("sale-ticket-detail-drawer-set-list not found");
  }
  saleTicketDetailDrawerSetList.innerHTML = "";
  tickets.forEach((ticket, index) => {
    const li = document.createElement("li");
    li.innerText = ticket.subject;
    li.classList.add("list-item");
    saleTicketDetailDrawerSetList.appendChild(li);
  });

  // 販売チケット詳細ドロワーの購入ボタン
  const saleTicketDetailDrawerBuyAnchor = document.getElementById(
    "sale-ticket-detail-drawer-buy-anchor",
  ) as HTMLAnchorElement | null;

  if (!saleTicketDetailDrawerBuyAnchor) {
    throw new Error("saleTicketDetailDrawerBuyAnchor not found");
  }

  saleTicketDetailDrawerBuyAnchor.href = saleTicket.ticketUrl;

  locateSaleTicketDetailDrawer();
}

/** 販売チケット詳細ドロワーの位置を調整する */
export function locateSaleTicketDetailDrawer() {
  const detailDrawer = document.getElementById("sale-ticket-detail-drawer");
  if (!detailDrawer) {
    throw new Error("sale-ticket-detail-drawer not found");
  }
  const saleTicketDetailDrawerHandle = document.getElementById(
    "sale-ticket-detail-drawer-handle",
  );
  if (!saleTicketDetailDrawerHandle) {
    throw new Error("sale-ticket-detail-drawer-handle not found");
  }
  const saleTicketDetailDrawerContent = document.getElementById(
    "sale-ticket-detail-drawer-content",
  );
  if (!saleTicketDetailDrawerContent) {
    throw new Error("sale-ticket-detail-drawer-content not found");
  }
  // ドロワーの初期位置をウィンドウ幅に応じて設定する
  const windowWidth = window.innerWidth;
  if (windowWidth >= MOBILE_WIDTH) {
    // PC画面では、navbarの下端にドロワーを配置する
    if (detailDrawer.style.top !== "") {
      // ドロワーが開いている時のみ(=インラインスタイルでtopが設定されている時)
      detailDrawer.style.top = `${
        UPPER_NAVBAR_HEIGHT + MIDDLE_NAVBAR_HEIGHT
      }px`;
      detailDrawer.style.height = `calc(100vh - ${UPPER_NAVBAR_HEIGHT}px)`;
    }
    // PC画面では、ドロワーのハンドルを非表示にする
    saleTicketDetailDrawerHandle.style.display = "none";
    // ドロワーの幅を固定値に設定する
    detailDrawer.style.width = "500px";
  } else {
    // モバイル画面では、ドロワーの初期位置をnavbarの下端に設定する
    if (detailDrawer.style.top !== "") {
      // ドロワーが開いている時のみ(=インラインスタイルでtopが設定されている時)
      // iOSの表示領域変動後でも古い固定値を使わず、現在の表示領域で再計算する。
      detailDrawer.style.top = `${getMobileDrawerInitialTop()}px`;
    }
    // モバイル画面では、ドロワーのハンドルを表示する
    saleTicketDetailDrawerHandle.style.display = "block";
    // モバイル画面では、ドロワーの幅をウィンドウ幅に設定する
    detailDrawer.style.width = `${windowWidth}px`;
  }
}

/** 販売チケット詳細ドロワーを閉じる */
export function closeSaleTicketDetailDrawer() {
  const detailDrawer = document.getElementById("sale-ticket-detail-drawer");
  if (!detailDrawer) {
    throw new Error("sale-ticket-detail-drawer not found");
  }
  detailDrawer.style.top = "";
}

/** フィルタードロワーを開いてチケット一覧を表示 */
export async function openFilterDrawer() {
  const loadingSpinner = document.getElementById(
    "filter-drawer-loading-spinner",
  );
  if (!loadingSpinner) {
    throw new Error("filter-drawer-loading-spinner not found");
  }
  loadingSpinner.style.display = "flex";
  try {
    const filterDrawer = document.getElementById("filter-drawer");
    if (!filterDrawer) {
      throw new Error("filter-drawer not found");
    }

    // フィルタドロワーが開いている状態であることを示すために
    // インラインスタイルにtop: 0px;をセットする
    filterDrawer.style.top = "0px";

    locateFilterDrawer();

    // チケット一覧を表示
    const filterDrawerSaleTicketContainer = document.getElementById(
      "filter-drawer-sale-ticket-container",
    );
    if (!filterDrawerSaleTicketContainer) {
      throw new Error("filter-drawer-sale-ticket-container not found");
    }
    const ticketConditionSelector = document.getElementById(
      "ticket-condition-selector",
    );
    if (!ticketConditionSelector) {
      throw new Error("ticket-condition-selector not found");
    }

    const location = window.location;
    const lang = location.pathname.split("/")[1];
    filterDrawerSaleTicketContainer.innerHTML = "";
    const saleTickets = await listAllSaleTickets(
      DATA_BLOCK.getEnv().API_URL,
      {
        showOutdated: (ticketConditionSelector as HTMLSelectElement).value as
          | "all"
          | "on-sale"
          | "not-sale",
      },
      lang as Languages,
    );
    saleTickets.forEach((saleTicket) => {
      const ticketCard = createTicketCard(saleTicket, DATA_BLOCK.getI18n());
      ticketCard.addEventListener("click", () => {
        window.dispatchEvent(
          new CustomEvent("changeModeToSaleTicket", {
            detail: { id: saleTicket.topics_id },
          }),
        );
      });
      filterDrawerSaleTicketContainer.appendChild(ticketCard);
    });
  } finally {
    loadingSpinner.style.display = "none";
  }
}

/** フィルタードロワーの配置場所や縦横を決定して適用する。 */
export function locateFilterDrawer() {
  const filterDrawer = document.getElementById("filter-drawer");
  if (!filterDrawer) {
    throw new Error("filter-drawer not found");
  }
  // ドロワーの初期位置と幅をウィンドウ幅に応じて設定する
  const windowWidth = window.innerWidth;
  if (windowWidth >= MOBILE_WIDTH) {
    // フィルタードロワーが開いているとき、topを変更する
    if (filterDrawer.style.top !== "") {
      filterDrawer.style.top = `${
        UPPER_NAVBAR_HEIGHT + MIDDLE_NAVBAR_HEIGHT
      }px`;
    }
    // ドロワーの幅を固定値に設定する
    filterDrawer.style.width = "500px";
  } else {
    // モバイル画面では、ドロワーの位置を全画面にに設定する
    if (filterDrawer.style.top !== "") {
      filterDrawer.style.top = "0px";
    }
    // モバイル画面では、ドロワーの幅をウィンドウ幅に設定する
    filterDrawer.style.width = `${windowWidth}px`;
  }
}

/** フィルタードロワーを閉じる */
export function closeFilterDrawer() {
  const filterDrawer = document.getElementById("filter-drawer");
  if (!filterDrawer) {
    throw new Error("filter-drawer not found");
  }
  filterDrawer.style.top = "";
}
